import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { GroupedPackageResult } from '../Models/package';
import { Tenant } from '../../../../Models/tenant';
import { PackageCreationRules } from '../Models/package-creation-rules';

@Injectable({
    providedIn: 'root',
})
export class PackageService {
    constructor(private http: HttpClient) { }

    private apiUrl = '/api/package/';

    getPackages(tenant: Tenant, page: number = 1, pageSize: number = 25): Promise<GroupedPackageResult> {
        return this.http
            .get<GroupedPackageResult>(`${this.apiUrl}get/${tenant.TenantId}?page=${page}&pageSize=${pageSize}`)
            .toPromise()
            .then(response => response)
            .catch(this.handleError);
    }

    getPackageCreationRules(tenant: Tenant, moduleId: string): Promise<PackageCreationRules> {
        return this.http
            .get<PackageCreationRules>(`${this.apiUrl}get/package-creation-rules/${tenant.TenantId}/${moduleId}`)
            .toPromise()
            .catch(this.handleError);
    }

    createPackage(tenant: Tenant, moduleId: string, createNewMajorVersion: boolean = false): Promise<any> {
        console.log("Create Package Service : " + tenant.TenantId + moduleId);

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = {
            headers: headers
        };

        return this.http
            .post(`${this.apiUrl}create/${tenant.TenantId}/${moduleId}?createNewMajorVersion=${createNewMajorVersion}`, {}, options)
            .toPromise()
            .then((data) => {
                console.log("Posted data to package controller ok");
                return data;
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}
